export default __webpack_public_path__ + "static/media/Star.6c502a5d.svg";